export const generateGuid = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  );
};

export const isNullOrEmpty = (value) => {
  if (typeof value !== "undefined" && value) {
    return false;
  } else {
    return true;
  }
};

export const isNullOrWhiteSpace = (value) => {
  if (typeof value !== "undefined" && value !== "") {
    return false;
  } else {
    return true;
  }
};

export const isNullOrEmptyOrZero = (value) => {
  if (typeof value !== "undefined" && value && value.toString() !== "0") {
    return false;
  } else {
    return true;
  }
};

export const isNullOrLengthIsZero = (value) => {
  if (typeof value !== "undefined" && value !== "[Undefined]" && value && value.length !== 0) {
    return false;
  } else {
    return true;
  }
};

export const stripWhiteSpace = (value) => {
  if (typeof value !== "undefined" && typeof value === "string" && value != null && value != "") {
    return value.trim().replaceAll("\t", "").replaceAll("\r", "").replaceAll("\n", "").toString();
  }
  return value;
};

export const isColourDark = (colourToCompare) => {
  var colour = colourToCompare.charAt(0) === "#" ? colourToCompare.substring(1, 7) : colourToCompare;
  var r = parseInt(colour.substring(0, 2), 16); // hex To R
  var g = parseInt(colour.substring(2, 4), 16); // hex To G
  var b = parseInt(colour.substring(4, 6), 16); // hex To B
  return r * 0.299 + g * 0.587 + b * 0.114 > 187 ? false : true;
};

export const camelise = (str) => {
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
    if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
  });
};

export const preventEnter = () => {
  const form = document.getElementById("root");
  form.addEventListener("keypress", function (e) {
    if (e.keyCode === 13) {
      e.preventDefault();
    }
  });
};

export const sortArrayOptionsAlphabetically = (optionsArray, propertyKeyForStringValue) => {
  try {
    let sortedArray = optionsArray.toSorted((x1, x2) => {
      return x1[propertyKeyForStringValue].replaceAll(/\s/g, "").toLowerCase() <=
        x2[propertyKeyForStringValue].replaceAll(/\s/g, "").toLowerCase()
        ? -1
        : 1;
    });
    return sortedArray;
  } catch (error) {
    console.error(error);
    return optionsArray;
  }
};

export const filterNestedObject = (obj, keysToFilter) => {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map((item) => filterNestedObject(item, keysToFilter));
  }
  return Object.keys(obj).reduce((acc, key) => {
    if (keysToFilter.includes(key)) {
      return acc;
    }

    if (typeof obj[key] === "object") {
      acc[key] = filterNestedObject(obj[key], keysToFilter);
    } else {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
};

export const arraysAreEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false;
  arr1.sort();
  arr2.sort();
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) return false;
  }
  return true;
};
